import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

import { computed } from 'vue';
    import AQButton from '@/components/shared/forms/inputs/AQButton.vue';
    import { AQToggleItem } from '@/interfaces/components/AQToggle.types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AQToggle',
  props: {
    modelValue: {},
    items: {},
    mandatory: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    const emit = __emit;

    const model = computed({
        get: (): T => props.modelValue,
        set: (value: T) => emit('update:modelValue', value),
    });

return (_ctx: any,_cache: any) => {
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!

  return (_openBlock(), _createBlock(_component_v_btn_toggle, {
    modelValue: model.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
    class: "aq-toggle",
    mandatory: __props.mandatory,
    disabled: __props.disabled,
    density: "compact"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
        return (_openBlock(), _createBlock(AQButton, {
          key: String(item.value),
          value: item.value,
          size: "small"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.label), 1)
          ]),
          _: 2
        }, 1032, ["value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue", "mandatory", "disabled"]))
}
}

})